import React from 'react';
import gql from 'graphql-tag';
import Image from '../Image';
import { graphql } from 'react-apollo';
import StripeCheckout from 'react-stripe-checkout';
import { browserHistory } from 'react-router';
import { fromGlobalId } from 'graphql-relay';
import Container from '../Container';
import styles from './payment.css';
import uuid from 'uuid';
import moment from 'moment';

function PaymentButtonComponent({ mutate, submission }) {
    const stripeKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
    const submissionId = fromGlobalId(submission.id).id;
    console.log('submission', submission);

    const onToken = payload => {
        return mutate({
            variables: {
                paymentToken: payload.id,
                submissionId: submission.id,
                clientMutationId: uuid.v4()
            }
        })
            .then(() => {
                browserHistory.push(`/payment/${submissionId}/success`);
            });
    };

    let paymentSection;

    if(submission.state === 'paid') {
        paymentSection = `This course has already been paid for on ${moment(submission.paidAt).format('dddd, MMMM Do YYYY, hh:mm a')}`;
    } else if(submission.course.state === 'closed'){
        paymentSection = 'This course is now closed and no longer accepting payments';
    } else if(submission.state ==='rejected'){
        paymentSection = 'You are not eligible to attend this course';
    } else {
        paymentSection = <StripeCheckout
            name="Code At Uni"
            description={`Fee for "${submission.course.name}" at ${submission.course.university.name}`}
            currency="GBP"
            amount={submission.course.price}
            email={submission.user.email}
            token={onToken}
            stripeKey={stripeKey}
        />;
    }

    return (
        <div className={styles.container}>
            <Container>
                <Image src="/Payment.jpg" alt="Code at Uni head image"/>
            </Container>
            <Container>
                {paymentSection}
            </Container>
        </div>
    );
}

const PaymentButton = graphql(gql`
mutation completePayment($submissionId: ID!, $clientMutationId: String!, $paymentToken: String!){
    completePayment(input: {
        clientMutationId: $clientMutationId,

        payment: {
            submissionId: $submissionId,
            paymentToken: $paymentToken
        }
    }) {
        updatedSubmission {
            id,
            paymentId
        }
    }
}
`)(PaymentButtonComponent);

function Payment({ data: { loading, submission }, ...props }) {
    if (loading) {
        return <div>Loading</div>;
    } else {
        return (
            <div>
                <PaymentButton submission={submission} {...props}/>
            </div>
        );
    }
}

export default graphql(gql`
    query($submissionId: String!){
        submission(id: $submissionId) {
            id
            paidAt
            state

            course {
                id
                name
                daysToPay
                price
                state
                university {
                    name
                }
            }
            user {
                id
                firstName
                lastName
                email
            }
        }
    }
`, {
    options({ params: { id }}) {
        const submissionId = id.split('&')[0];
        return { variables: { submissionId }};
    }
})(Payment);



/** WEBPACK FOOTER **
 ** ./src/Payment/index.js
 **/